<template>
    <div class="bodyClass">
        <!--首页大框-->
        <div class="ph-top-box-ins">
             <mobileMenu />
            <!--菜单-->
            <!-- <div class="ph-logo-a4 mt10 pl10">
                <a href="#" class="dbi fl he40">
                    <img src="../../assets/mobile/images/logo2.png" width="" height="45" alt="" /></a>
                <a href="#" class="dbi fr he20 white pr10 mt14 mr12">
                    <span class="f14 txtsh">MENU</span>
                    <i class="fa fa-bars f18 txtsh"></i></a>
            </div> -->
            <!--菜单end-->
            <!-- <div class="ph-phone-mu" style="">
                <ul class="ph-ph-um-ul">
                    <li class="ph-ph-mu-li mt10"><a href="/mb/homeWebMb" class="db  f15 lp2 pl10 white txtsh">首页</a></li>
                    <li class="ph-ph-mu-li mt10"><a href="chanping-1.html" class="db white f15 lp2 pl10 txtsh">产品</a>
                        <div class="" style="">
                            <a class="db he34 ml50 ph-pml-a" href="chanping-4.html">视觉智能体</a>
                            <a class="db he34 ml50 ph-pml-a" href="chanping-3.html">新一代公共安全视觉智能体</a>
                            <a class="db he34 ml50 ph-pml-a" href="chanping-1.html">视觉大模型平台</a>
                            <a class="db he34 ml50 ph-pml-a" href="chanping-2.html">视觉大模型一体机</a>
                        </div>
                    </li>
                    <li class="ph-ph-mu-li mt10"><a href="jiejfa-1.html" class="db white txtsh f15 lp2 pl10">解决方案</a>
                        <div class="" style="">
                            <a class="db he34 ml50 ph-pml-a" href="jiejfa-1.html">公共安全行业解决方案</a>
                            <a class="db he34 ml50 ph-pml-a" href="yijii-2.html">应急行业解决方案</a>
                            <a class="db he34 ml50 ph-pml-a" href="chengguan-3.html">城管行业解决方案</a>
                            <a class="db he34 ml50 ph-pml-a" href="jiaotong-4.html">交通行业解决方案</a>
                            <a class="db he34 ml50 ph-pml-a" href="qiyuegl-5.html">企业管理解决方案</a>
                        </div>
                    </li>
                    <li class="ph-ph-mu-li mt10"><a href="severHtml.html" class="db white txtsh f15 lp2 pl10">服务&生态</a>
                    </li>
                    <li class="ph-ph-mu-li mt10"><a href="gywmHtml.html" class="db white txtsh f15 lp2 pl10">关于我们</a>
                    </li>
                </ul>
            </div> -->
            <!--背景图-->
            <!-- <div class="ph-top-backgr">
                <div class="ph-top-box-ins-img"
                    style="background:url(../../assets/mobile/images/bana-9.jpg) center center no-repeat;background-size:cover;">
                </div>
                <div class="ph-top-box-ins-imga1"
                    style="background:url(../../assets/mobile/images/z8-ytj.png) center center no-repeat;background-size:cover;">
                </div>
            </div> -->
             <div class="ph-top-backgr ">
                <div class="ph-top-box-ins-img img1"></div>
                <div class="ph-top-box-ins-imga1 img2"></div>
            </div>
            <!--背景图end-->

            <!--首页大框end-->
        </div>
        <!--首页大框-->

        <div class="ph-main pt24">
            <div class="w100 lh40 tc"> <span class="db f40 fb lp2 mt40">新一代公共安全视觉智能体</span> 
            <span class="db f20  lp1 mt10 ph-col-gr">Next-Generation Public Security Visual Intelligent Agent</span> </div>
            <div class="w90 jz mt40 lh30 f16">
                <p class="f20 fb mb30 tc">产品介绍</p>
                <p class="tl mb40">以视觉大模型为核心感知中枢，为安防场景下机器人、机器狗、无人机、无人车、执法记录仪等具身智能设备构建 “小脑 + 大脑” 双重能力体系，赋能其成为具备自主安防感知与决策的智能体。方案通过视觉智能体为智能终端赋予媲美生物视觉的动态分析能力，使其既能依托 “小脑” 般的精准控制实现实时动作把控，又能凭借 “大脑” 般的深度逻辑决策支撑复杂场景研判 。 这种双重能力让智能体彻底突破传统 “指令 - 执行” 模式，在动态公共安全场景中实现 “感知即决策”，重新定义具身智能设备的自主协同边界，推动智能体从被动响应向主动交互、自主协同的高阶形态演进。</p>
                <p class="f20 fb mb30 tc">产品能力</p>
                <p class="f16 fb tl" style="color:rgb(255,0,0);">语音调度指挥行动</p>
                <p class="tl">支持以语音交互的方式指挥智能终端设备载体行动，可动态创建专属命令，驱动智能体主动开展环境洞察任务 ，智能体能基于命令快速启动视觉感知与数据解析，实时识别指定物体、捕捉物体行为、感知环境变化。</p>
                <p class="f16 fb tl" style="color:rgb(255,0,0);">智能定义自动巡逻</p>
                <p class="tl">支持智能终端（无人车、机器人等）自助规划巡逻路线，并以全自动方式完成指定区域内的巡逻任务，终端搭载的视觉智能体能精准识别并捕捉区域内的异常入侵、物品异动、人员违规滞留等安防事件，实现全天候智能值守</p>
                <p class="f16 fb tl" style="color:rgb(255,0,0);">动态场景自主适应</p>
                <p class="tl">面对动态变化的复杂场景，大幅降低智能体因 “场景变化导致的系统失效成本”。通过打通 “感知 - 计算 - 执行” 全链路协同，从 “固定场景专用” 升级为 “多场景自适应”, 驱动智能体快速适配环境变量。</p>
                <p class="f20 fb tc">产品优势</p>
                <img src="../../assets/mobile/images/ggan_cqys_mb.jpg" width="100%" />
                <p class="f20 fb mb30 tc">产品说明</p>
                <img src="../../assets/mobile/images/ggaq_jgt_1.jpg" width="100%" />
                <img src="../../assets/mobile/images/ggaq_jgt_2.jpg" width="100%" />
                <p class="f20 fb mb30 tc">典型场景</p>
                <p class="f14 fb tl">社会安全</p>
                <img src="../../assets/mobile/images/shean_01.jpg" width="47%" class="mr12"/>
                <img src="../../assets/mobile/images/shean_02.jpg" width="47%"/>
                <img src="../../assets/mobile/images/shean_03.jpg" width="47%" class="mr12"/>
                <img src="../../assets/mobile/images/shean_04.jpg" width="47%"/>
                <p class="f14 fb tl">交通安全</p>
                <img src="../../assets/mobile/images/jan_01.jpg" width="47%" class="mr12"/>
                <img src="../../assets/mobile/images/jan_02.jpg" width="47%"/>
                <img src="../../assets/mobile/images/jan_03.jpg" width="47%" class="mr12"/>
                <img src="../../assets/mobile/images/jan_04.jpg" width="47%"/>
                <p class="f14 fb tl">其他</p>
                <img src="../../assets/mobile/images/qt_01.jpg" width="100%"/>
                <img src="../../assets/mobile/images/qt_02.jpg" width="100%"/>
                <img src="../../assets/mobile/images/qt_03.jpg" width="100%"/>
            </div>

        </div>
        <!--内容大框end-->
        <!--底宣-->

        <!--底宣end-->
        <!--底宣2-->
        <div class="ph-btto-b-a1 ov mt40">
            <div class="mt10 w95 jz pt10 pb10">
                <div class="tc"> <img src="../../assets/mobile/images/ying-28.jpg" width="76" height="76" alt="" class="dbi" /> </div>
                <ul class="w100 ov mt10">
                    <li class="tc">
                        <div class=" f16 white tc">上海谛视万象科技有限公司</div>
                        <div class="ov mt10 tc"><span class="dbi ph-btto-b-sp "><img src="../../assets/mobile/images/ico2_3.png" width="28" height="28" alt="" /></span><span class="dbi  ml10 mt4 f14 ph-col-gr3">联系电话：4007628008</span></div>
                    </li>
      
                </ul>
            </div>
        </div>
        <!--底宣2end-->
        <!--底宣3-->
        <div class="he90 tc ph-btto-c"> <span class="db ph-col-gr3  pt18">辽ICP备2025061615号</span>
            <span class="db ph-col-gr3  mt10">Copyright © 2004 - 2025 谛视万象版权所有</span>
        </div>
        <!--底宣3end-->
    </div>
</template>
<script setup>
import mobileMenu from './mobile-menu.vue';
</script>
<style scoped>
@import '@/assets/mobile/css/default.css';
@import '@/assets/mobile/css/font-awesome.min.css';
@import '@/assets/mobile/css/margin.css';
@import '@/assets/mobile/css/main.css';

.img1 {
    background: url(../../assets/mobile/images/bana-9.jpg) center center no-repeat;
    background-size: cover;
}

.img2 {
    background: url(../../assets/mobile/images/z8-ytj.png) center center no-repeat;
    background-size:300%,100%,cover;
}
</style>